<template>
    <div class="obrazec obnova ovoj" id="html">
        <div class="glava">
            <div class="levi-logo">
              <img src='~@/assets/tuvsudlogo.png'/>
            </div>

            <div class="center-info">
                ZAPISNIK IN POROČILO O OCENITVI EKO
            </div>


            <div class="desni-info">
                <p>Obr. 7.4.-<span v-if="shema=='EKO PRI'">00</span><span v-if="shema=='EKO PRE'">01</span></p>
                <p>Izdaja: 8</p>
            </div>
        </div>
		<div class="noga-izven">
        		<div><div>Pripravil/a: Liljana Šurlan</div><div>14.9.2023</div></div>
                <div><div>Pregledal/a in odobril/a: Andreja Kranjc</div><div>14.9.2023</div></div>
                <div><div>Velja od:</div><div>14.9.2023</div></div>
      	</div>
        <div id="vsebina">
		<kbutton class="gumbtiskaj" :theme-color="'primary'" :rounded="'full'" id="tiskaj">
			<font-awesome-icon icon="print"  size="6x"/>
		</kbutton>
		<div class="mt-1" style="font-size:0.8em;">
			<p>
        <b>ZAPISNIK IN POROČILO O OCENITVI</b>&nbsp;
        <b v-if="shema=='EKO PRI'">za pridelavo in predelavo na kmetijskem gospodarstvu </b>
        <b v-if="shema=='EKO PRE'">v predelovalnih obratih, pri uvoznikih in trgovcih ekoloških pridelkov / živil in krme </b>
        <br>
        V obratu se izvede kontrolni pregled z namenom ugotavljanja izpolnjevanja zahtev z Uredbo (EU) št. 2018/848 in Uredbo o ekološki  pridelavi in predelavi kmetijskih pridelkov in živil Ur. l. RS št. 105/2022, Pravilnikom o evidencah s področja ekološke pridelave in predelave kmetijskih pridelkov in živil Ur. l. RS št. 105/2022):
      </p>
		</div>


		<table class="zapisnik-podatki mt-1">
			<colgroup>
				<col style="width:30%">
                <col style="width:30%">
				<col style="width:auto">
			</colgroup>  
			<tr>
				<td class="td-bold td-grey">1. Podatki o stranki</td>
                <td class="td-bold td-grey">Kontrolna številka stranke:</td>
				<td>{{pridelovalec.kontrolnaStevilka}}</td>
			</tr>
            <tr>
				<td class="td-bold">Ime in priimek stranke:</td>
              
				<td colspan="2">{{nosileckmg.naziv }}</td>
			</tr>
            <tr>
				<td class="td-bold">Naslov in pošta:</td>
              
				<td colspan="2">{{ nosileckmg.naslov }}, {{ nosileckmg.postnastevilka }} {{ nosileckmg.posta }}</td>
			</tr>
            <tr>
				<td class="td-bold">Prisotna oseba ob kontroli:</td>
              
				<td colspan="2">{{kontrola.prisotnaoseba}}</td>
			</tr>
            <tr v-if="shema=='EKO PRI'">
				<td class="td-bold">Lokacija kmetije:</td>
              
				<td colspan="2">{{ kontaktkmg.naslov }}, {{ kontaktkmg.postnastevilka }} {{ kontaktkmg.posta }}</td>
			</tr>
      <tr v-if="shema=='EKO PRE'">
				<td class="td-bold">Lokacija obrata:</td>
              
				<td colspan="2">{{ kontrola.lokacijaobrata }}</td>
			</tr>
            <tr>
				<td  class="td-bold">Vrsta predelave:</td>
              
				<td colspan="2">{{kontrola.vrstapredelave}}</td>
			</tr>
            <tr>
				<td  class="td-bold">Uporaba zaščitnih znakov:</td>
              
				<td colspan="2" >{{kontrola.zascitniznaki}}</td>
			</tr>
			<tr>
				<td class="td-bold td-grey">2. Podatki o kontroli:</td>
				 <td colspan="2"></td>
			</tr>
            <tr>
				<td class="td-bold">Ime in priimek kontrolorja:</td>
              
				<td colspan="2" >{{kontrolorjiSifrant.find(i=>i.id==kontrola.kontrolor).naziv}}</td>
			</tr>
            <tr>
				<td class="td-bold">Datum kontrole, čas (od-do):</td>
              
				<td colspan="2" >{{kontrola.zacetekkontrole.toLocaleDateString('SL-si')}} {{kontrola.zacetekkontrole.toLocaleTimeString('SL-si')}} - {{kontrola.koneckontrole.toLocaleDateString('SL-si')}} {{kontrola.koneckontrole.toLocaleTimeString('SL-si')}}</td>
			</tr>
            <tr>
				<td class="td-bold">Vrsta kontrolnega pregleda:</td>
              
				<td colspan="2" >{{kontrola.vrstakontrole}} {{kontrola.nacinkontrole}} </td>
			</tr>
            <tr>
				<td class="td-bold">Drugi prisotni:</td>
              
				<td colspan="2" >{{kontrola.drugiprisotni}}</td>
			</tr>
		</table>

		<table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				<col style="width:10%">
                <col style="width:70%">
                <col style="width:10%">
                <col style="width:10%">
				<col style="width:10%">
			</colgroup>  
			<tr>
				<td class="td-bold td-grey" colspan="2" rowspan="2">3. Kontrolne točke po Katalogu nepravilnosti in kršitev</td>
                <td class="td-grey"></td>
                <td class="td-grey" colspan="2">Skladnost</td>
			</tr>
            <tr>
				<td class="td-grey">P*</td>
                <td class="td-grey">DA</td>
                <td class="td-grey">NE</td>
			</tr>
            <tr v-for="(kt,index) in kontrola.kontrolnetocke" :key="kt.stevilka">
				<td>{{kt.stevilka}}.</td>
				<td>{{kt.naziv}}</td>
				<td>{{kt["P*"]?"X":""}}</td>
				<td>{{kt["DA"]?"X":""}}</td>
				<td>{{kt["NE"]?"X":""}}</td>
				
			</tr> 
        </table>
        <div style="font-size:0.8em">
         <div>*P - kontrolne točke ter ugotovitve (skladnost), ki so predmet pregleda so označene z X. V primeru, da kontrolna točka ni bila predmet kontrole in pregleda, polja pustimo prazna.</div>
         <div v-if="kontrola.neskladja.length<1">Pri kontrolnem pregledu <b>ni bilo ugotovljenih neskladij</b></div>
         <div v-if="kontrola.neskladja.length>0">Pri kontrolnem pregledu <b>so bila ugotovljena neskladja</b> in so zapisana v obrazcu (Obr. 7.4-04), ki je sestavni del tega zapisnika. Druge opombe so navedene na tem obrazcu, pod sekcijo 4. Ugotovitve.</div>
         <div v-if="kontrola.vzorcenje">V obratu <b>je bil odvzet vzorec</b> z zapisnikom o odvzemu vzorca, ki je sestavni del tega zapisnika.</div>
         <div v-if="!kontrola.vzorcenje">V obratu <b>nismo odvzeli vzorca</b></div>
         <div>S podpisom se stranka / odgovorna oseba strinja z vsebino zapisnika in zgoraj navedenih prilog ter se obvezuje, da bo odpravila vsa ugotovljena neskladja v določenem roku kot je zapisano v obrazcu (Obr. 7.4-04).</div>
         <div>Pripombe stranke na zapisnik, so navedene v sekciji 5. Pripombe. Stranka je seznanjena, da lahko poda ugovor v pisni obliki na podane neskladnosti, ugotovljene ob kontrolnem pregledu v roku 15 dni od dneva kontrole. Zapisnik je sestavljen v 2 izvodih, od katerega prejme stranka en izvod ali eno kopijo zapisnika.</div>
      

        </div>

        
			<br/>
        <div class="sekcija-nb">
			<div class="td-bold fake-td" >4. Ugotovitve</div>
      <pre>{{kontrola.ugotovitve}}</pre>
    </div>
    <div class="sekcija-nb">
		<div class="td-bold fake-td" >5. Pripombe</div>
    		<pre>{{kontrola.pripombe}}</pre>
      </div>
			
      <div class="sekcija-nb">
        <table style="border-left:0;border-right:none;border-bottom:none;border-top:none;height: 1px;" class="zapisnik-podatki mt-1">
			<colgroup>
				  <col style="width:5%">
          <col style="width:70%">
          <col style="width:25%">
		  	</colgroup>  
			<tr>
        <td style="border-left:0;border-right:none;border-bottom:none;border-top:none">&nbsp;</td>
        <td style="border-left:0;border-right:none;border-bottom:none;border-top:none">&nbsp;</td>
     
        <td style="border-left:0;border-right:none;border-bottom:none;border-top:none">&nbsp;</td>
      </tr>
      <tr>
        <td style="border-left:0;border-right:none;border-bottom:none;">&nbsp;</td>
        <td style="border-left:0;border-right:none;border-bottom:none;"class="td-small">ODGOVORNA / POOBLAŠČENA OSEBA</td>
        <td style="border-left:0;border-right:none;border-bottom:none;"class="td-small">ZA CERTIFIKACIJSKI ORGAN</td>
      </tr>
        </table>
      </div>
      <div class="sekcija-nb">
        <table class="zapisnik-podatki mt-1" style="height: 1px;">
			<colgroup>
				  <col style="width:16.66%">
          <col style="width:16.66%">
          <col style="width:16.66%">
          <col style="width:16.66%">
          <col style="width:16.66%">
          <col style="width:16.66%">
		  	</colgroup>  
			<tr>
        <td colspan="3" class="td-bold td-grey td-small" >6. Pregled zapisnika, odprave neskladij in rezultatov analiz</td>
        <td colspan="3" class="td-bold td-grey td-small" >7. Odločitev o izdaji certifikata</td>
      </tr>
      <tr>
        <td class="td-small td-grey">Datum:</td>
        <td class="td-small td-grey">Pripravil:</td>
        <td class="td-small td-grey">Podpis:</td>
        <td class="td-small td-grey">Datum:</td>
        <td class="td-small td-grey">Odobril/a:</td>
        <td class="td-small td-grey">Podpis:</td>
      </tr>
      <tr>
        <td class="td-grey">&nbsp;</td>
        <td class="td-grey">&nbsp;</td>
        <td class="td-grey">&nbsp;</td>
        <td class="td-grey">&nbsp;</td>
        <td class="td-grey">&nbsp;</td>
        <td class="td-grey">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="3" class="td-grey td-small" >Rezultati analize odvzetih vzorcev so ustrezni:</td>
        <td colspan="3" class="td-grey td-small" >Certifikat odobren po seznamu proizvodov / dejavnosti:</td>
      </tr>
      <tr>
        <td colspan="3" class="td-grey td-small" style="vertical-align: middle;" ><input type="checkbox"/> DA <input type="checkbox"/> NE</td>
        <td colspan="3" class="td-grey td-small" style="vertical-align: middle;"><input type="checkbox"/> DA <input type="checkbox"/> NE <input type="checkbox"/> DELNO ODOBREN <input type="checkbox"/> ŽE IZDAN CERTIFIKAT</td>
      </tr>
      <tr>
        <td colspan="6" class="td-grey td-small" style="vertical-align: middle;" >Posredovana dokazila o odpravi neskladnosti so primerna in zadostna: <input type="checkbox"/> DA <input type="checkbox"/> NE &nbsp;&nbsp;&nbsp;Podpis:</td>
      </tr>
        </table>
		
      </div>
	
    </div>
    </div>
   

</template>

<style scoped>

	
	.gumbtiskajskrit {
            display:none;
        }
	.zapisnik-glava{
		
		background-color:#d9d9d9;
		border:1px solid black;
		text-align: center;
		padding:1mm;
        
	
	}
	.zapisnik-glava h2{
		color:black;

	}
	table.zapisnik-podatki {
		width:100%;
        font-size:0.9em;
	}
	table.zapisnik-podatki, table.zapisnik-podatki td{
		border: 1px solid black;
		border-collapse: collapse;
		
	} 
	table.zapisnik-podatki td{
		padding-left: 1mm;
		padding-right: 1mm;
	}
	table.zapisnik-podatki td .multi-td{
		display:flex;
		border:none;
		 align-items: stretch;
		  height: 100%;
	}
	table.zapisnik-podatki td .multi-td div{
		flex: 1 1 33%;
		padding-left: 1mm;
		padding-right: 1mm;

	}
	table.zapisnik-podatki td .multi-td div:first-child{
		
		padding-left: 0;
		

	}
	table.zapisnik-podatki th{
		font-weight: normal;
		background-color:#d9d9d9;
		text-align: left;
		border: 1px solid black;
		border-collapse: collapse;
		padding-left: 1mm;
		padding-right: 1mm;
	}

  
	table.zapisnik-podatki td.td-grey,.fake-td{
		background-color:#d9d9d9;
		border-left:1px solid black;
		border-right:1px solid black;
		
	}
	.td-bold {
		font-weight: bold;
	}
	table.zapisnik-podatki td.td-regular {
	background-color:white;
	}
	.zapisnik-tabela-glava {
		background-color:var(--accent) !important;
		color:black;
		font-weight: bold;;

	}
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}


h1,h2,h3{
  font-size:5mm;
  line-height:5mm;
}

@media print {
.sekcija-nb {
  break-inside: avoid!important;
	  }
}

.noga-noter {

display:    flex ;
flex-direction:     row ;
justify-content:    end;
margin-top:2rem;
}

.datum,.podpis {
  margin-right: 10rem;
  font-size: 1rem;
}


.tabela-kultura-wrapper {
  column-count:2;
  
}
.tabela-proizvod-wrapper {
  column-count:3;
  
}
.tabela{
  width: 100%;
  table-layout: fixed;
}
.tabela th {
  font-size: 0.5rem;
}


.tabela td,.tabela,.tabela th {
  
  border: 1px solid green;
  border-collapse: collapse;
  padding:3px;
  font-size: 0.7rem;
}

label,textarea{
  break-inside: avoid !important;
   
}
.glava{
  
  display:    flex ;
  flex-direction:     row ;
  justify-content:    space-between  ;
  

}
.levi-logo  {
 position:   running(obrazecLeviLogo); 

}  

.levi-logo img{
  height: 2cm;

}
.center-info {
  position:   running(obrazecCenterInfo);

  font-weight:bold;
}
.desni-info {
  position:   running(obrazecDesniInfo);
}

.desni-info p{
  
  margin: 0;
  font-size:  0.4cm;
  line-height:   0.4cm;
  text-align:     right   ;
}



.noga {

  position:   running(obrazecNoga);
  font-size: 3mm ;
  line-height:5mm;
  display:    flex ;
  flex-direction:     row ;
  justify-content:    space-between;
}

.stevilka-strani:after{
content: counter(page) " od " counter(pages);
}


label.k-form-field{
  font-weight:    bold;
  font-size:  0.8em;
  line-height:    0.8em;
  margin-top:2mm;
  margin-bottom:1mm;
}
.posta input:nth-child(1){
  flex-basis: 15%;
  margin-right: 3mm;

}
h6, .td-small{
  font-size: 0.7em;
}

.sekcija {
  margin-top:5mm;
  border:   1px solid green;
  padding: 2mm;
 
}
.sekcija-pb1 {
  padding-bottom:1mm;
}

.posebnosti .seznamkategorij
{
  border-bottom:  1px solid green;
}
.izjava ul{
  list-style-type: disc;
margin-top: 3mm;
margin-bottom: 3mm;
margin-left: 0;
margin-right: 0;
padding-left: 10mm;
}
.vrsticapodpisa div {
  flex-basis: 50%;
}
.noga-izven{
position:  running(nogaRunning);
display:flex;
flex-direction:row;
font-size: 3mm ;
line-height:5mm;
width:100%;
justify-content:space-between;

}

.zacetek-strani {
break-before: always;
}
.pagedjs_page .pagedjs_margin-bottom-center>.pagedjs_margin-content>.noga-izven{
  display:flex;
}
@page {

margin-top: 25mm;
margin-bottom: 25mm;
margin-left: 15mm;
margin-right: 15mm;
size: A4 portrait;

@bottom-center {
content:  element(nogaRunning);
vertical-align: top;
}
@top-left {
content:  element(obrazecLeviLogo);
vertical-align: middle;
}

@top-center {
content:  element(obrazecCenterInfo);
vertical-align: middle;
}

@top-right {
content:  element(obrazecDesniInfo);
vertical-align: middle;
}



}


</style>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { Input } from '@progress/kendo-vue-inputs';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { MultiSelect,DropDownList,ComboBox } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';

import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { sifrant } from '../store/sifrant.module';
import { kontrolaService } from '../services/kontrola.service';

import { Previewer,registerHandlers,Handler  } from 'pagedjs';


class RepeatingTableHeaders extends Handler {
 
	
    constructor(chunker, polisher, caller) {
        super(chunker, polisher, caller);
        this.splitTablesRefs = [];
    }
	beforeParsed(content) {
		//console.log("Before preview!!!!!!!!!!!!!!!!!!!!!!")
		console.log(content);
		let gumbtiskaj=content.getElementById('tiskaj');
		//console.log("najdem gumb tiskaj")
		gumbtiskaj.remove();
		this.gumbtiskaj=gumbtiskaj;
	}
	afterPreview(content, renderTo) {
		let gumbtiskaj=this.gumbtiskaj;
		console.log("After preview!!!!!!!!!!!!!!!!!!!!!!")
		console.log(this.gumbtiskaj);
		gumbtiskaj.style.position="fixed";
		gumbtiskaj.style.top="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.onclick=function(){
			this.remove();
			window.print();
			document.body.appendChild(this);
		}
		document.body.appendChild(this.gumbtiskaj);
		}

    afterPageLayout(pageElement, page, breakToken, chunker) {
		console.log("after afterPageLayout!!!!!!!!!!!!!!!!!!!!!!")
        this.chunker = chunker;
        this.splitTablesRefs = [];

        if (breakToken) {
            const node = breakToken.node;
            const tables = this.findAllAncestors(node, "table");
            if (node.tagName === "TABLE") {
                tables.push(node);
            }

            if (tables.length > 0) {
                this.splitTablesRefs = tables.map(t => t.dataset.ref);

                //checks if split inside thead and if so, set breakToken to next sibling element
                let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
                if (thead) {
                    let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
                    breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
                }

                this.hideEmptyTables(pageElement, node);
            }
        }
    }

    hideEmptyTables(pageElement, breakTokenNode) {
        this.splitTablesRefs.forEach(ref => {
            let table = pageElement.querySelector("[data-ref='" + ref + "']");
            if (table) {
                let sourceBody = table.querySelector("tbody > tr");
                if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
                    table.style.visibility = "hidden";
                    table.style.position = "absolute";
                    let lineSpacer = table.nextSibling;
                    if (lineSpacer) {
                        lineSpacer.style.visibility = "hidden";
                        lineSpacer.style.position = "absolute";
                    }
                }
            }
        });
    }

    refEquals(a, b) {
        return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
    }

    findFirstAncestor(element, selector) {
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                return element.parentNode;
            }
            element = element.parentNode;
        }
        return null;
    }

    findAllAncestors(element, selector) {
        const ancestors = [];
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                ancestors.unshift(element.parentNode);
            }
            element = element.parentNode;
        }
        return ancestors;
    }

    // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
    layout(rendered, layout) {
        this.splitTablesRefs.forEach(ref => {
            const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
            if (renderedTable) {
                // this event can be triggered multiple times
                // added a flag repeated-headers to control when table headers already repeated in current page.
                if (!renderedTable.getAttribute("repeated-headers")) {
                    const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
                    this.repeatColgroup(sourceTable, renderedTable);
                    this.repeatTHead(sourceTable, renderedTable);
                    renderedTable.setAttribute("repeated-headers", true);
                }
            }
        });
    }

    repeatColgroup(sourceTable, renderedTable) {
        let colgroup = sourceTable.querySelectorAll("colgroup");
        let firstChild = renderedTable.firstChild;
        colgroup.forEach((colgroup) => {
            let clonedColgroup = colgroup.cloneNode(true);
            renderedTable.insertBefore(clonedColgroup, firstChild);
        });
    }

    repeatTHead(sourceTable, renderedTable) {
        let thead = sourceTable.querySelector("thead");
        if (thead) {
            let clonedThead = thead.cloneNode(true);
            renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
        }
    }

    // the functions below are from pagedjs utils/dom.js
    nodeAfter(node, limiter) {
        if (limiter && node === limiter) {
            return;
        }
        let significantNode = this.nextSignificantNode(node);
        if (significantNode) {
            return significantNode;
        }
        if (node.parentNode) {
            while ((node = node.parentNode)) {
                if (limiter && node === limiter) {
                    return;
                }
                significantNode = this.nextSignificantNode(node);
                if (significantNode) {
                    return significantNode;
                }
            }
        }
    }

    nextSignificantNode(sib) {
        while ((sib = sib.nextSibling)) {
            if (!this.isIgnorable(sib)) return sib;
        }
        return null;
    }

    isIgnorable(node) {
        return (node.nodeType === 8) || // A comment node
            ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
    }

    isAllWhitespace(node) {
        return !(/[^\t\n\r ]/.test(node.textContent));
    }

}

registerHandlers(RepeatingTableHeaders);



export default {
  components:{
	'kinput': Input,
	'kbutton': Button,
	'kendo-datepicker': DatePicker,
	'kendodatetimepicker': DateTimePicker,
    'multiselect': MultiSelect,
    'kendo-checkbox': Checkbox,
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
      'combobox': ComboBox,
      'dropdownlist': DropDownList,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko,
	  upload: Upload,
  },
  props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
			ipobsegcertificiranjafilter:{},
			ip:{},
			kontrola:{
				podrocjecertificiranja:"",
                drugiprisotni:"",
                kontrolnetocke:[],

				status:"",
				stkontrole:0,
				datumnadzora:new Date(),
                pripravazapisnika:new Date(),
                odobritevzapisnika:new Date(),
                pricetekveljave:new Date(),

				vrstakontrole:"",
                zascitniznaki:"",
                vrstapredelave:"",
                prisotnaoseba:"",
				lokacijakontrole:"",
				zacetekkontrole:new Date(),
				koneckontrole:new Date(),
				trajanje:0,
				gumbtiskaj:"gumbtiskajskrit",
				vzorcenje:true,
				vzorci:[],
				neskladja:[],
				prisotneosebe:[],
				seznam:[],
				storitvepodizvajalca:[],
				podizvajalci:[{naziv:"",naslov:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				storitvepodizvajalca:[{naziv:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				neskladnosti:"",
				posebnosti:"",
				ponovna:"",
				zuppripombe:false,
				zuppripomba:"",
				zupposlannaemail:"", //email iz podatkov
				zupprevzetnasedezu:"",
				zupprevzetobkontroli:"",
				zakljuceno:"",
				izvajalcikontrole:[{naziv:"",datum:new Date(),edit:true}]
			},
			files:[],
			kontrolorji:[],
			kontaktkmg:{naslov:"",posta:"",postnastevilka:""},
			nosileckmg:{naslov:"",posta:"",postnastevilka:""},
			sifrantTree:{},
			podrocjaip:[],
            dataLoading:false,
			podrocjacertificiranja:[{"naziv":"IPS","id":1, "prikaz":"IPSO"},{"naziv":"IPG","id":2, "prikaz":"IPG"},{"naziv":"IPP","id":3, "prikaz":"IPP"},{"naziv":"IPZ","id":4, "prikaz":"IPZ"},{"naziv":"IPH","id":5, "prikaz":"IPH"}],
           statusnadzora:[
			{id:1,naziv:"nova"},
			{id:2,naziv:"v teku"},
			{id:3,naziv:"odločitev"},
			{id:4,naziv:"konec"},
		   ],
		   statusprisotnihoseb:[
			{id:1,naziv:"izvajalec"},
			{id:2,naziv:"pooblaščenec"},
			{id:3,naziv:"ostali prisotni"},
			
		   ],
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' } 
            ],
            columns: [

               { field: "zaporednastevilka", title:"ID nadzora",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editable:false},
			   { field: "statusnadzora", title:"Status nazdora",width: "150px"},
			   { field: "shema", title:"shema"},
			   { field: "podrocje", title:"podrocje"},
			   { field: "izvajalec", title:"izvajalec"},
			   { field: "naslov", title:"naslov"},
			   { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "trajanje", title:"Trajanje (h)",width: "80px",filterable:false,type:"number",editor:"numeric",format:"{0:n2}"},
            
			   { field: "vrstakontrole", title:"Vrsta kontrole",width: "150px"},
			   { field: "kontrolor", cell:"kontrolor", title:"Kontrolor",width: "240px"},
               { field: "mnenjekontrolorja", title:"Mnenje",width: "90px"},
             
			   { field: "tveganje", title:"Ocena tveganja"},
			   { field: "cena", title:"cena"},
			   { field: "statusplacila", title:"Status plačila"},
			 
                //{ field: "vzorci", title:"Vzorci",width: "100px"},
                //{ field: "posebnosti", title:"Posebnosti",width: "100px"},
                //{ field: "priloge", title:"Priloge",width: "100px"},
                //{ field: "sifrakontrolorja", title:"Kontrolor",width: "100px"},
              /*   { field: "kolicina", title:"Količina",width: "100px",filterable:false,type: "number",footerCell: this.nogaVsotaKolicina,width: "150px",format: '{0:n2}'},
                { field: "merskaenotanaziv", title:"Enota",width: "100px",filterable:false},
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable:false, title:"Datum določitve statusa",width: "170px", cell:this.formatDate},
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
               // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title:"Status",width: "150px"},
                */
                { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrola.kontrola;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
        kontrolorjiSifrant(){
          return this.kontrolorji.map(i=>{
                i.naziv=i.priimek+' '+i.ime;
                return i;            
          })
        }
      
           },
	 
beforeDestroy() {
  //window.removeEventListener('beforeunload', this.beforeWindowUnload)
},
    created () {
	//	window.addEventListener('beforeunload', this.beforeWindowUnload)
 if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
		
	  this.naloziPodatke();

      
    },
  


    methods: {
		confirmLeave() {
    return window.confirm('Zapuščate stran. Ali ste shranili vse spremembe?')
  },

  confirmStayInDirtyForm() {
	//tukaj lahko preverim, če se je kaj spremnijalo...
    return !this.confirmLeave()
  },

  beforeWindowUnload(e) {
    if (this.confirmStayInDirtyForm()) {
      // Cancel the event
      e.preventDefault()
      // Chrome requires returnValue to be set
      e.returnValue = ''
    }   
  },
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne','save']),
        ...mapActions('kontrola', ['load','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrola',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
        formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
		storitvepodizvajalcachange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		
		dodajizvajalcikontrole(){
            if(!this?.kontrola?.izvajalcikontrole)
                this.kontrola.izvajalcikontrole=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.izvajalcikontrole.push(newRecord);
        }   ,
        removeizvajalcikontrole(e){
        
                var index=this.kontrola.izvajalcikontrole.indexOf(e);
                if(index>=0)
                        this.kontrola.izvajalcikontrole.splice(index,1)

        },
        izvajalcikontrolechange: function (e) {
            e.dataItem[e.field]=e.value;
		},

		authorize(event) {
			event.headers=authHeader();
		},
		onAdd(event) {
		
        this.files=event.newState;
      },
      onRemove(event) {
        this.files=event.newState;
      },
      onProgress(event) {
		console.log("progres");
		console.log(event);
		this.files=event.newState;
      },
      onStatusChange(event) {
		
		console.log("done");
		console.log(event)
		this.files=event.newState;
		Vue.set(this.kontrola,'seznam',{datotekaid:event.response?.response?._id,files:this.files});
      },

		saveData(e){
          //this.save( this.dataSezona);
        },
		handleSubmit(e){

		e.preventDefault();
		},
		onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			console.log(this.ipobsegcertificiranjafilter[podshema])
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;
		 let sezona=this.dataSezona.sezona;
		 let shema=this.shema;
		 let pridelovalecid=this.pridelovalecid;
		 let thisComp=this;
		 var sifranti=[
		  this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjieko"}).then(

		  	data=>{
				this.kontrolorji=this.sifrant["kontrolorjieko"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
			//mogoče filter po vrsti
		this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja)
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
				
        }),
		this.naloziSifrant({sezona:sezona,sifrant:"podrocjaip"}).then(()=>{
            thisComp.podrocjaip=thisComp.sifrant["podrocjaip"];
		})];
		
		Promise.all(sifranti).then(()=>{
			console.log("Šifranti naloženi")
        

          
		this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{

			console.log("Grem po stranko")
			
			let kontaktkmg=p.kontakt.find(k=>k.vloga=="kmetija (kmg)")
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt.find(k=>k.glavni)
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt[0];

			let nosileckmg=p.kontakt.find(k=>k.vloga=="nosilec kmg")
                if(!nosileckmg)
					nosileckmg=p.kontakt.find(k=>k.glavni)
                if(!nosileckmg)
					nosileckmg=p.kontakt[0];
			this.kontaktkmg=kontaktkmg;
			this.nosileckmg=nosileckmg;
			let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
		if(!pridelava){
			//javi napako, ne dodaj podatkov
			console.log("resne težave, če ni sheme")
			return;
		}
		//naloži kontrolo, če je id, če ni, napaka...
		this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
		let novaprijava={
		obseg:{},
		seznam:{datotekaid:null,files:[]},
		datumseznama:(new Date()).toISOString()};

		if(!pridelava.ip)
		{
			Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		if(!pridelava.ip.prijava){
		Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		Vue.set(thisComp,"ip",pridelava.ip)
		thisComp.files=thisComp.ip.prijava?.seznam?.files;
		
		if(!thisComp.ip.prijava.obseg||Array.isArray(thisComp.ip.prijava.obseg))
		Vue.set(thisComp.ip.prijava,'obseg',{});

		this.ip.prijava.datumseznama=provideIntlService(thisComp).parseDate( this.ip.prijava.datumseznama)

		kontrolaService.loadOne(sezona,pridelovalecid,shema,this.kontrolaid).then(
			data=>{

				
				var datumi=["datumkontrole","datumnadzora","zacetekkontrole","koneckontrole","datumnajave","pripravazapisnika","odobritevzapisnika","pricetekveljave"]
				//vzorci datum pregleda
				//datumzadnjeaktivnosti podizvajalci in stortivepodizvajalca
				//izvajalcikontrole datum
				
				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
                    else
                        data[d]=new Date();
				}
				

            Vue.set(data,'kontrolnetocke',data.kontrolnetocke);
				Vue.set(thisComp,'kontrola',data);
                console.log("thisComp.kontrola.kontrolnetocke");
                console.log(thisComp.kontrola.kontrolnetocke);

			
				let paged = new Previewer();
      			paged.preview();

			},
			err=>{}
		);

		

	  

		});

	});
          
        
      
        },
		
        sifranKontrolaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
        sifrantNacinChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


           
            if(!dataItem.oldValues["nacinkontrole"])
              dataItem.oldValues["nacinkontrole"] =dataItem["nacinkontrole"];



      
              Vue.set( dataItem, 'nacinkontrole',e.value.naziv);
            
    
        },
          sifranMnenjeChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            
            if(!dataItem.oldValues["mnenjekontrolorja"])
              dataItem.oldValues["mnenjekontrolorja"] =dataItem["mnenjekontrolorja"];

            Vue.set( dataItem, 'mnenjekontrolorja',e.value.naziv);
            
            
    
        },
        sifranMestoChange: function(e,dataItem) {

          
if(!dataItem.oldValues)
dataItem.oldValues={}



if(!dataItem.oldValues["mestokontrole"])
dataItem.oldValues["mestokontrole"] =dataItem["mestokontrole"];

Vue.set( dataItem, 'mestokontrole',e.value.naziv);



},

        kontrolorChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["kontrolorid"])
              dataItem.oldValues["kontrolor"] =dataItem["kontrolor"];

         
            Vue.set( dataItem, 'kontrolor',e.value.id);
            this.test=e.value.id
         
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontrolepridelovalca"][0].id,
                  vrstakontrole:this.sifrant["vrstakontrolepridelovalca"][0].naziv,
                  nacinkontrole:this.sifrant["nacinkontrolepridelovalca"][0].naziv,
                  mestokontrole:this.sifrant["mestokontrolepridelovalca"][0].naziv,
                  //mestokontrole:"",
                  mnenjekontrolorjaid:this.sifrant["mnenjekontrolorja"][0].id,
                  mnenjekontrolorja:this.sifrant["mnenjekontrolorja"][0].naziv
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
        //tu je treba dodat še shemo...
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'kontrola', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id} });
             //this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
             // });



        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        async shraniKontrole () {
			//kaj narediš s seznamom in obsegom.... vprašaj...
			this.save( this.dataSezona);
			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid)
			
			//shrani obseg...

              //this.save();
    },
       
        
    }
};
</script>

